import React from 'react';
import { StoreItemType, StoreSectionProps } from '../types/storeDefinitions';
import {
  paddleBaddleStoreInfo,
  astroVoltsStoreInfo,
  webWhackerStoreInfo,
  sunrockProtectorStoreInfo
} from '../data/stores';
import { Box, Card, Typography, Link,} from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';


const StoreItem = ({...store}:StoreItemType) => {
  const StoreIcon = store.storeName === 'Apple App Store' ? PhoneIphoneIcon : PhoneAndroidIcon;
  return (
    <Card variant='elevation' className='store-details' sx={{backgroundColor: '#282c34'}} aria-label={`store link for ${store.storeName}`}>
      <StoreIcon className='store-item-icon'/>
      <Typography variant='h6' >
        <Link href={store.link}>{store.storeName}</Link>
      </Typography>
    </Card>
  )
}


const ProductSection = ({product}:StoreSectionProps) => {
  return (
    <Box className='store-box' aria-label={`store section for ${product.appName}`}>
      <Typography variant='h5' className='store-name'>
        <img alt={`product logo for ${product.appName}`} src={product.productLogo} height={110} className='image-item'/>
        <Box>
          <Box style={{margin: 'auto', textAlign: 'center'}}>
            {product.appName}
          </Box>
          <hr/>
          <Typography variant='body1' className='product-description'>{product.description}</Typography>
        </Box>
      </Typography>
        {product.stores.map(store =>
        <StoreItem
          {...store}
        />
        )}
    </Box>
  )
}


const HomePage = () => {

  return (
    <Box className='content-container'>
      <ProductSection product={sunrockProtectorStoreInfo} />
      <ProductSection product={paddleBaddleStoreInfo} />
      <ProductSection product={astroVoltsStoreInfo} />
      <ProductSection product={webWhackerStoreInfo} />
    </Box>
  )
}

export default HomePage;
